module.exports = __webpack_public_path__ + "static/media/SM-2MTJ.63b07365.png";